module.exports = __webpack_public_path__ + "assets/img/item01.849bcb63.png";